import { useMutation } from '@tanstack/react-query';
import { axiosInstance } from '../../utils';
import { BrollCaptionVideo } from '../../@types';

interface Payload {
  videoId: string;
  name: string;
}

const cloneBrollCaption = async (payload: Payload): Promise<BrollCaptionVideo> => {
  const res = await axiosInstance.post('/api/video/clone-video', payload);
  return res.data;
};

export const useCloneBrollCaption = () => {
  return useMutation(cloneBrollCaption, { onSuccess: (data) => data });
};
